import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { CreateReportAccessInformationCredentialsForm } from "app/component/report-access-information-credentials/CreateReportAccessInformationCredentialsForm";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import {
    createReportVersionAccessInformationCredentialsRoute,
    reportVersionAccessInformationRoute,
} from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { useReportVersionAccessInformationQuery } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";

export const CreateReportVersionAccessInformationCredentialsScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(createReportVersionAccessInformationCredentialsRoute);
    const [created, setCreated] = useState(false);

    const { data, loading, error } = useReportVersionAccessInformationQuery({
        variables: { versionId: reportVersionGraphId(versionId) },
    });
    const accessInformation = data?.reportVersion?.accessInformation;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (accessInformation == null) {
        return <ErrorScreen title="Error" message="Not found." />;
    }

    return created ? (
        <Navigate to={reportVersionAccessInformationRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={createReportVersionAccessInformationCredentialsRoute} />
                <CreateReportAccessInformationCredentialsForm
                    accessInformationId={accessInformation._id}
                    onCreate={() => setCreated(true)}
                />
            </Container>
        </NavigationScreen>
    );
};
